import { handle420 } from 'apis/HandleError';

export const fetchPolygonData = (url, options) => {
    return fetch(url, { ...options })
      .then( res => {
        if (!res.ok) { throw res }

        return res.json()  //we only get here if there is no error
      })
      .catch((e) => {
        console.log('fetch data error = ' + e.status);
        switch (e.status) {
          case 420:
            handle420();
            break;
          default:
            throw e;
        }
        return;
      });
  };